import { Box, Skeleton, Stack } from "@mui/material";

interface ITableEntitySkeletonProps {
    animation?: "pulse" | "wave" | false;
    backgroundColor?: string;
}

export const TableEntitySkeleton = ({ animation = "pulse", backgroundColor }: ITableEntitySkeletonProps) => {
    return (
        <Stack
            direction="row"
            sx={{
                gap: 1,
                alignItems: "center",
                width: "100%",
            }}
        >
            <Skeleton
                variant="circular"
                width={40}
                height={40}
                animation={animation}
                sx={{ flexShrink: 0, margin: 0, ...(backgroundColor && { backgroundColor }) }}
            />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                    flexGrow: 1,
                    overflow: "hidden",
                }}
            >
                <Skeleton
                    variant="rounded"
                    height="19px"
                    width="100%"
                    animation={animation}
                    sx={{ maxWidth: "200px", margin: 0, ...(backgroundColor && { backgroundColor }) }}
                />
                <Skeleton
                    variant="rounded"
                    height="19px"
                    width="100%"
                    animation={animation}
                    sx={{ maxWidth: "160px", margin: 0, ...(backgroundColor && { backgroundColor }) }}
                />
            </Box>
        </Stack>
    );
};
